import React from "react";
import { formatPurseWithoutCurrency } from "@tvg/formatter/currency";
import { Button } from "@tvg/design-system";
import { NullaryFn } from "@tvg/ts-types/Functional";
import { useSelector } from "react-redux";
import { getUserBalanceIsShown } from "@tvg/pp/src/store/selectors";
import { Container } from "./styled-components";

interface Props {
  qaLabel?: string;
  balance: number;
  onAccBalanceClick: NullaryFn<void>;
}

const AccountBalance = ({
  qaLabel = "account-balance",
  balance,
  onAccBalanceClick
}: Props) => {
  const isUserBalanceShown = useSelector(getUserBalanceIsShown);

  const displayBalance = () => {
    if (!isUserBalanceShown) {
      return "Deposit";
    }

    return typeof balance === "number" && isUserBalanceShown !== "0"
      ? formatPurseWithoutCurrency(balance)
      : "--";
  };

  const isBalanceLow =
    isUserBalanceShown && typeof balance === "number" && balance <= 10;
  return (
    <Container data-qa-label={qaLabel}>
      <Button
        qaLabel="account-balance-button"
        variant={isBalanceLow ? "betting" : "secondary_dark"}
        size="m"
        iconPosition="start"
        icon="deposit"
        onPress={onAccBalanceClick}
      >
        {displayBalance()}
      </Button>
    </Container>
  );
};
export default AccountBalance;
